export default __webpack_public_path__ + "images/b830e427565f0851760bae0089185535-search_sp3_2@2x.png";